//<editor-fold desc="Main Actions">
export const TOGGLE_APP_DRAWER = 'TOGGLE_APP_DRAWER'
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE'
export const SHOW_RESPONSE_ERROR_DIALOG = 'SHOW_RESPONSE_ERROR_DIALOG'
export const HIDE_RESPONSE_ERROR_DIALOG = 'HIDE_RESPONSE_ERROR_DIALOG'
export const SHOW_PROFILE_DIALOG = 'SHOW_PROFILE_DIALOG'
export const FETCH_DASHBOARD = 'FETCH_DASHBOARD'
//</editor-fold>

//<editor-fold desc="Auth Module Actions">
export const AUTH_LOG_USER_IN = 'LOG_USER_IN'
export const AUTH_LOG_USER_OUT = 'LOG_USER_OUT'
export const AUTH_CHANGE_PIN = 'AUTH_CHANGE_PIN'
export const AUTH_REQUEST_PASSWORD_RECOVERY = 'AUTH_REQUEST_PASSWORD_RECOVERY'
export const AUTH_VALIDATE_RECOVERY_CODE = 'AUTH_VALIDATE_RECOVERY_CODE'
export const AUTH_CHANGE_PASSWORD_WITH_RECOVERY_CODE = 'AUTH_CHANGE_PIN_WITH_RECOVERY_CODE'
export const AUTH_LOG_USER_IN_WITH_TOKEN = 'AUTH_LOG_USER_IN_WITH_TOKEN'
export const INIT_STORE = 'INIT_STORE'
export const AUTH_INIT_MODULE = 'AUTH_INIT_MODULE'
export const SET_INVALID_TOKEN = 'SET_INVALID_TOKEN'
export const ORDER_CONFIRMATION = 'ORDER_CONFIRMATION'
export const SET_IS_ORDER_CONFIRMATION = 'SET_IS_ORDER_CONFIRMATION'
export const SET_IS_DELETE_CONFIRMATION = 'SET_IS_DELETE_CONFIRMATION'
//</editor-fold>

/** @deprecated */
export const USER_DAILY_MENU = 'USER_DAILY_MENU'
export const USER_SETTINGS_4_ORDERING = 'USER_SETTINGS_4_ORDERING'

export const SWITCH_DAILYMENU = 'SWITCH_DAILYMENU'
export const SAVE_DAILYMENU = 'SAVE_DAILYMENU'
export const STORNO_DAILYMENU = 'STORNO_DAILYMENU'
export const SAVE_RESTORE_DAILYMENU = 'SAVE_RESTORE_DAILYMENU'
export const SET_SELECTED_VIEW = 'SET_SELECTED_VIEW'
export const FETCH_STRUCTURED_MENU_OFFER = 'FETCH_STRUCTURED_MENU_OFFER'
export const FETCH_OFFER_RESERVATION = 'FETCH_OFFER_RESERVATION'
export const PLACE_NEW_RESERVATION = 'PLACE_NEW_RESERVATION'
export const CHANGE_EXISTING_RESERVATION = 'CHANGE_EXISTING_RESERVATION'
export const CANCEL_EXISTING_RESERVATION = 'CANCEL_EXISTING_RESERVATION'
export const RESTORE_EXISTING_RESERVATION = 'RESTORE_EXISTING_RESERVATION'

export const FETCH_MY_LATEST_INVOICES = 'FETCH_MY_LATEST_INVOICES'
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE'

export const FETCH_ACCOUNT_EMAILS = 'FETCH_ACCOUNT_EMAILS'
export const FETCH_ACCOUNT_USER = 'FETCH_ACCOUNT_USER'
export const UPDATE_ACCOUNT_EMAILS = 'UPDATE_ACCOUNT_EMAILS'
export const UPDATE_ACCOUNT_USER = 'UPDATE_ACCOUNT_USER'

export const FETCH_CALENDAR_EVENTS_FOR_DAY = 'FETCH_CALENDAR_EVENTS_FOR_DAY'

export const FETCH_CREDIT_DETAILS = 'FETCH_CREDIT_DETAILS'
export const FETCH_INVOICES = 'FETCH_INVOICES'
export const FETCH_INVOICE_DETAIL = 'FETCH_INVOICE_DETAIL'
export const UPDATE_PERSON_CREDENTIAL_PASS_BY_ID = 'UPDATE_PERSON_CREDENTIAL_PASS_BY_ID'
export const FETCH_TENANT_NAME = 'FETCH_TENANT_NAME'

export const SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM'

export const FETCH_RESERVATION_BY_ID = 'FETCH_RESERVATION_BY_ID'


export const SET_MODE = 'SET_MODE'
export const SET_CONTROL_BUTTONS_MODE = 'SET_CONTROL_BUTTONS_MODE'
export const SET_CID_MODE = 'SET_CID_MODE'
export const SET_TT_MODE = 'SET_TT_MODE'
export const SHOW_LOGOUT_BUTTON_MODE = 'SHOW_LOGOUT_BUTTON_MODE'
export const SHOW_LOGOUT_TIMER_MODE = 'SHOW_LOGOUT_TIMER_MODE'

export const FETCH_ALLERGEN_LIST = 'FETCH_ALLERGEN_LIST'
export const FETCH_FOOD_ITEM_IMAGES = 'FETCH_FOOD_ITEM_IMAGES'
export const SWITCH_APPLICATION_LANGUAGE = 'SWITCH_APPLICATION_LANGUAGE'

export const CUSTOMER_FETCH_CUSTOMER_LIST = 'CUSTOMER_FETCH_CUSTOMER_LIST'
export const BOARDER_FETCH_BOARDER_GROUP_LIST = 'BOARDER_FETCH_BOARDER_GROUP_LIST'
export const CREATE_NEW_REQUEST = 'CREATE_NEW_REQUEST'
export const FETCH_BOARDER_DATA = 'FETCH_BOARDER_DATA'
export const FETCH_SMART_LINK = 'FETCH_SMART_LINK'

export const DELETE_BOARDER = 'DELETE_BOARDER'
export const DELETE_CONFIRMATION = 'DELETE_CONFIRMATION'

export const FETCH_CUSTOMER_DATA = 'FETCH_CUSTOMER_DATA'
